var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#F7F3EF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.874 33.74L40.64 33.74 40.64 20.276 23.874 20.276zM14.986 1.904L16.78 1.904 16.78.21 14.986.21zM28.144 9.545c0 1.069-.803 1.936-1.793 1.936-.99 0-1.793-.867-1.793-1.936 0-1.07.803-1.937 1.793-1.937.99 0 1.793.867 1.793 1.937zM22.895 20.275L41.619 20.275 32.233 9.427z",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.056 15.458c0 1.069-.802 1.936-1.793 1.936-.99 0-1.792-.867-1.792-1.936 0-1.07.802-1.937 1.792-1.937s1.793.867 1.793 1.937zM32.258 13.532L32.258 17.353M34.027 15.442L30.49 15.442M26.352 7.635L26.352 11.456M28.121 9.545L24.584 9.545M23.847 33.739L40.641 33.739 40.641 31.273 23.847 31.273zM1.24 33.739L7.851 33.739 7.851 31.273 1.24 31.273z",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.837 33.739L23.858 33.739 23.858 31.273 7.837 31.273zM13.048 29.988L14.371 29.988 14.371 23.167 13.048 23.167zM14.371 29.988L15.694 29.988 15.694 23.167 14.371 23.167zM17.447 23.5c0-1.358 1.02-2.459 2.277-2.459 1.256 0 2.276 1.1 2.276 2.459",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.999 31.303L17.461 31.303 17.461 23.471 19.723 23.471 21.999 23.471z",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.351 32.533L23.845 32.533 23.845 31.3 14.351 31.3z",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.202 33.747L23.696 33.747 23.696 32.515 14.202 32.515zM29.044 29.988L30.643 29.988 30.643 23.167 29.044 23.167zM30.643 29.988L32.243 29.988 32.243 23.167 30.643 23.167zM32.243 29.988L33.842 29.988 33.842 23.167 32.243 23.167zM33.842 29.988L35.441 29.988 35.441 23.167 33.842 23.167zM21.343 27.003L21.343 28.216M22.905 20.275L32.243 9.427 41.629 20.275 42.823 20.276 32.236 8.041 21.705 20.276zM11.387 20.193L17.509 13.067 17.509 1.904 13.079 1.904zM23.459 6.143L17.509 6.143",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.634 8.741L26.415 2.71 6.347 26.024 7.763 26.024 26.427 4.341 30.942 9.545",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.634 8.741L26.415 2.71 6.347 26.024 7.763 26.024 26.427 4.341 30.942 9.545",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.264 16.163L36.211 6.143 29.385 6.143M12.711 20.275L40.517 20.275M12.687 6.143L4.712 6.143.195 20.275 8.685 20.276M23.845 20.276L23.845 33.731 7.851 33.731 7.851 26.024",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.541 21.635L11.541 33.74 1.234 33.74 1.234 20.276 11.153 20.276",
    transform: "translate(1 1.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.312 29.988L5.635 29.988 5.635 23.167 4.312 23.167zM6.958 26.024L6.958 29.988 5.635 29.988 5.635 23.167 6.958 23.167 6.958 25.314",
    transform: "translate(1 1.435)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7cda370e31ed36d5c60fbff35eb91242.svg";
export { ForwardRef as ReactComponent };